module.exports = __webpack_public_path__ + "img/t4-m8.4ef2eb99.png";